'use client'

import React, { useEffect } from 'react';
import useFormInitialStore from "@/store/form_initial";
import { routes } from '@/navigation';
import { ConfigSlimStep } from '@/types/configuration';
import { NavigationButtons } from '@/components/NavigationButtons';
import { advisoryHealthCheck } from '@/utils/client/client_api';

type Texts = {
    title: string;
    yes: string;
    no: string;
}

type Props = {
    texts: Texts
    configStep: ConfigSlimStep
}

const IsKnowWhatStudy = ({ texts, configStep }: Props) => {
    const { isKnowWhatStudy, setIsKnowWhatStudy, setHasPostHsTitles } = useFormInitialStore();

    useEffect(() => {
        advisoryHealthCheck();
    }, [])

    const handleClickOnSelectorButt = (yesOrNot: boolean) => async () => {
        setIsKnowWhatStudy(yesOrNot);
        setHasPostHsTitles(yesOrNot ? 1 : 0);
        return true;
    }

    return (
        <div className=" h-full col-span-12 lg:col-span-8 lg:col-start-3 flex flex-col justify-center">
            <div className="w-full">
                <h1 className='mb-10'>
                    {texts.title}
                </h1>
                <div className='grid grid-cols-12 lg:gap-4 mb-5'>
                    <div className='col-span-12 radio-button'>
                        <NavigationButtons
                            onClick={handleClickOnSelectorButt(true)}
                            text={texts.yes}
                            stepIsValidated={true}
                            next={routes[configStep.nextOptions[0].name]}
                            completedQuestion={configStep.routeName}
                            completedAnswer={{ 'isKnowWhatStudy': isKnowWhatStudy }}
                            margin='mb-5 lg:mb-0'
                        />
                    </div>
                    <div className='col-span-12 radio-button'>
                        <NavigationButtons
                            onClick={handleClickOnSelectorButt(false)}
                            text={texts.no}
                            stepIsValidated={true}
                            next={routes[configStep.nextOptions[1].name]}
                            completedQuestion={configStep.routeName}
                            completedAnswer={{ 'isKnowWhatStudy': isKnowWhatStudy }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IsKnowWhatStudy;